import { getConstants } from '../../api/externals-api';
import { IConstants } from '../../models/pro-sites';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_CONSTANTS_SUCCESS = 'LOAD_CONSTANTS_SUCCESS';

// Actions
export const loadConstantsSuccess = (constants: IConstants) => ({
    type: LOAD_CONSTANTS_SUCCESS,
    constants,
});

// Thunks
export const loadConstants = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const constants = await getConstants();
            dispatch(loadConstantsSuccess(constants));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
